// extracted by mini-css-extract-plugin
module.exports = {"RootCardTraffic":"DevicesScreen_RootCardTraffic__OF7fV"};